<template>
    <div id="library-page">

        <div class="profile-header">
<!--            <div class="relative">
                <div class="cover-container rounded-t-lg"></div>
            </div>-->
            <div class="flex items-center text-center flex-wrap profile-header-nav p-3" style="background: #fff">
                <ul style="width: 100%" class="text-sm">
                    <li v-for="(post, key, index) in item" :key="index" class="vs-tabs--li tabLink" :class="{activeChild:index === 0}" :id="'nav_'+key" @click="showContent(key)">
                        {{ post.title }}
                    </li>
                </ul>
            </div>
        </div>

        <div class="con-vs-tabs vs-tabs vs-tabs-primary vs-tabs-position-top">
            <div class="con-slot-tabs">
                <div class="con-tab vs-tabs--content">

                    <div class="vx-row flex content_all" v-for="(post, key, index) in item" :class="{active:index === 0}" :key="key" :id="'content_'+key">
                        <vx-card class="mt-base vx-col w-full lg:w-1/2" v-for="(post1, index1) in post.child" :key="index1">
                            <div>
                                <div class="post-header flex justify-between mb-4">
                                    <div class="flex items-center">
                                        <div class="ml-4">
                                            <h5><b>{{ post1.title }}</b></h5>
                                        </div>
                                    </div>
                                </div>

                                <div class="post-content ml-4">
                                    <p v-for="(post2, index2) in post1.child" :key="index2">
                                        <b>{{ post2.title }}</b>&nbsp; <small>{{ post2.created_at }}</small>
                                        <span class="news-content__inside__text mt-2"
                                              v-html="post2.description"></span>
                                        <span style="display: block" class="mt-3">
                                            <span class="post-comment">
                                                <a :href="post2.file" download>
                                                    <vs-button class="small">{{ $t('download') }}</vs-button>
                                                </a>
                                            </span>
                                        </span>
                                        <br>
                                    </p>
                                </div>
                            </div>
                        </vx-card>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                item: []
            }
        },
        methods: {
            showContent(ids){
                let content_all = document.getElementsByClassName('content_all');
                for (let i = 0; i < content_all.length; i++) {
                    content_all[i].classList.remove("active");
                }
                document.getElementById('content_'+ids).classList.add("active");

                let vsTab = document.getElementsByClassName('vs-tabs--li');
                for (let i = 0; i < vsTab.length; i++) {
                    vsTab[i].classList.remove("activeChild");
                }
                document.getElementById('nav_'+ids).classList.add("activeChild");

            }
        },
        created() {
            const thisIns = this;
            // eslint-disable-next-line no-undef
            axios.get(apiUrl + '/library/all?token=' + token)
                .then(function (response) {

                    let data = response.data;
                    if (data.code === 200) {
                        thisIns.item = data.data;
                    } else {
                        if (data.code === 401) {
                            window.logout();
                        }
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    }

                });
        }
    }
</script>

<style lang="scss" scoped>
    @import "@/assets/scss/vuesax/pages/profile.scss";

    #library-page {
        .cover-container {
            height: 60px;
            background-image: url("../../assets/images/pages/library.svg");
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
        }

        .tabLink{
            display: inline-block;
            background: #F5F7FA 0% 0% no-repeat padding-box;
            border-radius: 2px;
            color: #4C70B5;
            padding: 12px 70px;
            font: Medium 12px/15px Montserrat;
            margin-right: 12px;
            cursor: pointer;

            &.activeChild{
                background: #FFFFFF 0% 0% no-repeat padding-box;
                box-shadow: 0px 3px 3px #4C70B51A;
                border-radius: 2px;
                cursor: default !important;
            }
        }
        .content_all {
            display: none !important;
        }
        .content_all.active {
            display: flex !important;
        }
    }

</style>
